import StatusIndicator from './StatusIndicator';
import StatusIndicatorType from './StatusIndicatorType';
import statusIndicatorStyles from './statusIndicator.module.scss';

export { StatusIndicator, StatusIndicatorType, statusIndicatorStyles };

export default StatusIndicator;
